module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAAGpJREFUSA1jXCev/p9hEAKmQegmsJNGHUZqzIyG2LAJMRbFqHBSPUMX9Yz/gYAuNpFoyWjiJzHAGEZDbDTESA0BUtUz+uYsHpTFBcvl2y9I9Qxd1I/mSlKDeTTEhk2IsajKiXwl1Tf0UA8AcxENMAxaRKYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Netherlands.png
// module id = 480
// module chunks = 7